import ComparisonTableSection from '../ComparisonTableSection';

import { useTableStore } from '../../../store/useTableStore';
import ComparisonTableSectionProvider from '../ComparisonTableSectionProvider';
import SD4Table from './SD4Table';
import { SDProps } from './sd.interface';

const SD4 = ({ triggerCollapse, setTablesCollapsed, tablesCollapsed, collapseOnClick }: SDProps) => {
    const [data] = useTableStore((state) => [state.data]);

    return data && data.sd4 ? (
        <ComparisonTableSectionProvider>
            <ComparisonTableSection
                triggerCollapse={triggerCollapse}
                setTablesCollapsed={setTablesCollapsed}
                tablesCollapsed={tablesCollapsed}
                collapseOnClick={collapseOnClick}
                title={'4. Dealings'}
            >
                <SD4Table />
            </ComparisonTableSection>
        </ComparisonTableSectionProvider>
    ) : null;
};

export default SD4;
